import Axios from "axios";
import {
    SET_BANK_ACCOUNT_LIST,
    UNSET_BANK_ACCOUNT_LIST,
    SET_EDITING_BANK_ACCOUNT_LIST,
    UNSET_EDITING_BANK_ACCOUNT_LIST,
} from "@/store/mutation-types";
import { 
    getBankAccountList, 
    getBankAccountById,
    saveBankAccount,
    updateBankAccount,
} from "@/store/api";

// initial state
const state = {
    getBankAccountList: [],
    getEditingBankAccount: {},
};

const getters = {
    getBankAccountList(state) {
        return state.getBankAccountList;
    },
    getEditingBankAccount(state) {
        return state.getEditingBankAccount;
    },
};

const mutations = {
    [SET_BANK_ACCOUNT_LIST](state, data) {
        state.getBankAccountList = data;
    },
    [UNSET_BANK_ACCOUNT_LIST](state) {
        state.getBankAccountList = [];
    },
    [SET_EDITING_BANK_ACCOUNT_LIST](state, data) {
        state.getEditingBankAccount = data;
    },
    [UNSET_EDITING_BANK_ACCOUNT_LIST](state) {
        state.getEditingBankAccount = {};
    },
};

const actions = {
    saveBankAccount({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveBankAccount, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBankAccount({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${updateBankAccount}/${data.branch_id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBankAccountList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(getBankAccountList)
            .then(function (response) {
            commit('SET_BANK_ACCOUNT_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BANK_ACCOUNT_LIST');
            reject(error);
            });
        });
    },

    getBankAccountById({ commit }, data) {
        const getBankAccountRecordById = `${getBankAccountById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBankAccountRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};

